<template>
    <div id="feeDetail" class="app-inner">
         <div class="public-btn-small flex align-cen" style="padding-left:0;margin-bottom:16px">
            <div class="public-btn-small-plan"  @click="reback" style="margin-left:0">
                返回
            </div>
            </div>
             <div class="edit-from">
                          <div class="p-tit-c">
 <div class="businessDetail-info flex align-cen">
    <div class="businessDetail-info-con flex">
       <div class="list">
        问题类型：{{infoList.type == 1 ? '仿真软件问题' : infoList.type == 2 ? '课程问题' : '其他问题'}}
       </div>
         <div class="list">
        问题ID：{{infoList.id}}
       </div>
         <div class="list">
        问题提交手机号：{{infoList.loginName}}
       </div>
         <div class="list flex">
        问题提交团队：{{infoList.businessName}}
       </div>
        <div class="list">
      创建时间：{{infoList.createTime}}
       </div>
    </div>
 </div>
 </div>
      <div class="public-tit flex align-cen" style="margin:16px 0">
            <div class="public-tit-list">
                <i class="icon-al-user-fill"></i>  问题信息
            </div>
        </div>
        <div class="feedbackCon">
          <div>{{infoList.content}}</div>
          <div class="feedbackCon-img">
           <img :src="item" alt="" v-for="item in imgPath">
          </div>
        </div>
            </div>
    </div>
</template>
<script>
import { feedbackDetail } from "@/api/index/index" //详情
export default {
    name:'adminDetail',
    data: () =>{
        return {
            infoList:{
            },
            newArry:[],
            wechatArr:[],
            userinfo:[],
            imgPath:[],
        }
    },
    created(){
        this.getDetail()
        // this.$route.query.type==1表示企业管理员、2表示注册用户
    },
    methods: {
                 // 获取详情
        getDetail(){
          this.userinfo = []
              feedbackDetail({
                id:this.$route.query.id
              })
            .then(res => {
                this.infoList = res.data
                this.imgPath = res.data.pic.split(',');
            })
            .catch(err => {
            })
        },
        reback(){
            this.$router.push('/AppIssue') 
        }
    }
}
</script>
<style lang="scss" scoped>
#feeDetail{
   margin-bottom: 50px;
    .businessDetail-data-table{
        margin-top: 20px;
    }
    .feedbackCon-img{
      img{
        margin: 0 auto;
        display:block;
        margin-bottom: 20px;
      }
    }
      .businessDetail-info{
        padding: 30px 20px 20px 20px; 
        .businessDetail-info-logo{
            width: 200px;
            border-right: 1px solid #ccc;
            img{
                width: 100px;
                height: 100px;
                border-radius: 100px;
                margin: 0 auto;
                display: block;
            }
        }
        .businessDetail-info-con{
            width: calc(100% - 200px);
            padding: 0 20px;
            flex-wrap: wrap;
            .list{
                width: 33%;
                padding-bottom: 20px;
            }
        }
    }
}
@media (max-width: 1380px){
.maxwid{
width: 120px;
}
}

</style>
